import type { PointerEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@artosera/ui';
import { rectangleDe, type Placement } from '@artosera/shared';
import type { OeuvreAccrochage } from '../../api/accrochage.js';
import { VignetteOeuvre } from '../../composants/VignetteOeuvre.js';
import styles from './Accrochage.module.css';

export function PanneauOeuvres({
  oeuvres,
  placements,
  peutPlacer,
  onPlacer,
  onGlisser,
}: {
  oeuvres: OeuvreAccrochage[];
  placements: Placement[];
  peutPlacer: boolean;
  onPlacer: (id: string) => void;
  onGlisser: (e: PointerEvent<HTMLButtonElement>, id: string) => void;
}) {
  const { t } = useTranslation('regie');
  return (
    <aside className={styles.panel} aria-label={t('accrochage.oeuvres')}>
      <h2>{t('accrochage.oeuvres')}</h2>
      <p>{t('accrochage.aidePanneau')}</p>
      {oeuvres
        .filter((o) => !placements.some((p) => p.oeuvreId === o.id))
        .map((o) => (
          <div key={o.id} className={styles.oeuvre}>
            <VignetteOeuvre url={o.apercuUrl} />
            <div>
              <p>
                {o.artiste} — {o.titre}
              </p>
              {rectangleDe({ xCm: 0, yCm: 0 }, o.dimensions).provisoire && (
                <p>{t('accrochage.provisoire')}</p>
              )}
              <Button
                disabled={!peutPlacer}
                onClick={(e) => {
                  if (e.detail === 0) onPlacer(o.id);
                }}
                onPointerDown={(e) => onGlisser(e, o.id)}
              >
                {t('accrochage.placer', { titre: o.titre })}
              </Button>
            </div>
          </div>
        ))}
    </aside>
  );
}
